export default "__VITE_ASSET__DxSKcyM7__"